<template>
  <q-dialog v-model="dialogAffiliatePause">
    <q-card style="min-width: 600px">
      <q-toolbar class="bg-primary text-white">
        <q-toolbar-title> {{ $t('pause_reason') }} </q-toolbar-title>

        <q-btn flat round dense icon="mdi-close" @click="onClose" />
      </q-toolbar>

      <q-form @submit.prevent="pauseAffiliateStatus">
        <q-card-section class="scroll q-col-gutter-md" style="max-height: 70vh">
          <div class="col-12">
            <q-input
              v-model="text"
              outlined
              type="textarea"
              lazy-rules
              :rules="[isRequired]"
              counter
              maxlength="255"
              rows="15"
            />
          </div>
        </q-card-section>
        <q-card-actions align="right" class="q-pa-md">
          <q-btn outline :label="$t('cancel')" no-caps padding="sm lg" color="primary" @click="onClose" />

          <q-btn unelevated :label="$t('pause')" no-caps padding="sm lg" color="primary" type="submit" />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import AffiliateMixin from '../../mixins/AffiliateMixin';
import AffiliateService from '../../services/AffiliateService';

export default {
  name: 'FormAffiliatePause',
  mixins: [AffiliateMixin, AffiliateService],
  data() {
    return {
      text: ''
    };
  },
  methods: {
    onClose() {
      this.ActionSetDialogAffiliatePause(false);
    },
    async pauseAffiliateStatus() {
      this.onLoading(true);
      console.log(this.user);

      try {
        const { data, status } = await this.updateAffiliateStatus(this.affiliateSelect.id, 4, {
          text: this.text,
          user_name: this.user.name
        });
        if (status === 200 || status === 201) {
          this.getAffiliates();
          this.successNotify(data.message);
          this.onClose();
        }
      } catch (error) {
        if (error.response && error.response.status === 500) this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    }
  }
};
</script>

<style></style>
